module.exports = __webpack_public_path__ + "static/media/09n.1a868688.png";